import { render } from "./MuseumInfo.vue?vue&type=template&id=0d4abe96&scoped=true"
import script from "./MuseumInfo.vue?vue&type=script&lang=js"
export * from "./MuseumInfo.vue?vue&type=script&lang=js"

import "./MuseumInfo.vue?vue&type=style&index=0&id=0d4abe96&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4abe96"]])

export default __exports__